import React from 'react';

export function IllustrationNewWay(props) {
  return (
    <svg {...props} viewBox="0 0 708 573" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M414.74 305.29c0 3.69 7.32.44 9.11 1.34 2.27 1.13 2.68 4.31 3.16 6.49 1.62 7.39 2 15.09 4.63 22.25 1.46 4 5.34 12.9 11.13 10.84 2.36-.84 3.77-3.5 4.91-5.54 1.93-3.44 13.8-34.07 14.95-37.84a.72.72 0 0 0 0-.35.8.8 0 0 0-.1-.78 38 38 0 0 0-9-7.75.76.76 0 0 0-1 .13.82.82 0 0 0-.66.66c-.44 2.44-13.25 40.07-14.17 38-1.33-2.92-3.31-11.13-3.87-14.28-.72-4.09-1.9-8.83-4.59-12.21-2-2.46-3.93-3.16-7-3.73-1.7-.32-7.22.14-7.63 2.46.03.1.07.21.13.31z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M689.25 541.57a15.26 15.26 0 0 1-6 4.6c-6.08 2.88-13.35 3.22-20 3.29-18.19.2-36.3 3-54.36 1.36-5.42-.5-10.85-.91-16.28-1-43.65-.68-87.53 1.43-131.21 1.51-62.13.12-124.25-.72-186.37-1C183.05 550 0 560.41 0 543.86s47.26-7.7 68.23-8.25c48.62-1.28 97.26-1.82 145.88-3.19 70.92-2 141.88-3.1 212.81-3.68 49.2-.4 98.42-.53 147.62.35 35.52.64 71.15-.68 106.39 3.49 4.5.53 10.07 6.62 8.32 8.99z"
          fill="#9978FF"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M643.79 292c1.29 2 4.41 1.75 6.81 1.2 19.79-4.48 34.89-19.07 44.17-37.7a14.7 14.7 0 0 1 6.74-6.92c1.63-.75 6.54-.59 6.21-3.3-.42-3.6-8.57-1.75-10.47-.44-4.72 3.25-7.9 8.43-11.4 12.85-11.39 14.39-24.3 23.41-42.65 24V291a5.63 5.63 0 0 0 .42 2.68c.05.09.11-1.81.17-1.68z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M588.35 523.11c-.42-1.88-3.31-1.08-2.89.8.81 3.68-1.13 7.56-3.37 10.41-3.15 4-6.6 3.36-10.32.43-1.5-1.18-3.64.93-2.12 2.13 4.12 3.24 8.68 5.11 13.08 1.19 3.97-3.54 6.79-9.68 5.62-14.96zm48.24 12.25A8.5 8.5 0 0 1 626.33 524c.66-1.82-2.24-2.6-2.9-.8a11.51 11.51 0 0 0 14 15 1.5 1.5 0 0 0-.84-2.84zM393.6 291.43c-1.17 6.6-3.06 13.12-4 19.75a1.23 1.23 0 0 0 .91 1.32c2.84.77 6.74 3 9.34 2.51 3.42-.66 3.87-3.86 4.38-7.57.68-4.93 2.56-9.25 3.2-14.15a1.22 1.22 0 0 0-1-1.33 77.87 77.87 0 0 1-9.7-2.36 2.43 2.43 0 0 0-3.13 1.83z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M315.27 517.7c-.41-1.71-3-1-2.63.73 1.12 4.68 2.47 10.18-.38 14.55-2.85 4.37-7.92 3.23-12.19 4.29a1.37 1.37 0 0 0 .72 2.64c5.22-1.3 10.55-.37 13.84-5.55 3.29-5.18 1.95-11.2.64-16.66zm51.66 17.03c-2.4 1.23-5.57 1.55-7.81-.23a4.67 4.67 0 0 1-.73-6.67c1.2-1.28-.72-3.22-1.93-1.93a7.4 7.4 0 0 0 .25 10.11c3.06 3.15 7.94 2.94 11.6 1.08 1.57-.79.19-3.15-1.38-2.36z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M333.47 392.14c-3.33 28.91-9.72 69.82-11.56 98.86-.61 9.59-2 26.13-4.36 35.44-.69 2.7-1.54 3.49-4.32 3.68-2.83 0-5.1-46.24-5.36-55-.15-5-.39-14.78-.54-19.79-.14-4.8-2.25-56.75-2.71-69.73 7.21 2.36 18.64 1.1 25.85 3.47"
          fill="#46204F"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M398.45 303.33c-3 1-3.85 7.13-4.51 9.57-.79 3-1.48 5.92-2.19 8.89-.59 2.47-1.05 6.63-3 8.33-5.44 4.7-14.26-9.94-16.5-13.22-4.57-6.68-9.14-13.38-16-18-1.21-.82-2.92.83-2 2.05 1.56 2.21 1.52 6.89 2.13 9.5.93 4.06 1.4 8.89 3.2 12.71.04.14.1.28.18.4.06.11.12.21.2.31 5.95 9.1 21.43 20.89 31.39 10.91 3.83-3.84 4.5-8.54 5.24-13.64.56-3.9.33-12.37 3.35-15.32a1.51 1.51 0 0 0-1.49-2.49z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M91.5 273c-4.09-2.74-5.11-7.8-4.12-12.43.64-3 2.35-7.4 3-11.8a3 3 0 0 0 1.25.26c3.75 0 3.76-5.83 0-5.83a3.42 3.42 0 0 0-.46 0c.73-5.48 1.21-10.09 1-10.92-1.4-7.48-5-15.53-14.17-14.11-4.58.72-8.25 4.23-10 8.42-.42 1-2.44 11.51-1.33 11.43-.4 0-.29 2.17.28 5.66h-.41c-3.75 0-3.75 5.83 0 5.83.5 0 1-.12 1.43-.36.42 2 1.88 4.13 2.46 6.44 1.72 6.84 2.34 12.59-2.68 17.76-7.75 8-17.93 9.36-25 17.73 15.46-3.7 19.41 19 35.32 18.24 8.51-.4 29.48-26.6 36-31.77-8.66 1.81-15.18.37-22.57-4.55z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M276.91 266.6a2.46 2.46 0 0 0-3-1.7c-9.17 2.75-9.33 14.86-11.66 22.82-2.12 7.23-4.73 15.5-9.82 18.89-5.43 3.63-13.43-.39-17.67-7.59-3.09-5.25-6.89-20.28-6.89-20.28l-1.82 31.75c8.72 12 20.69 24.45 31.64 9.48 8.51-11.64 11.23-30.22 13.79-46.35.09-.59.18-1.19.24-1.8l.12-.1a9 9 0 0 1 3.36-2.13 2.48 2.48 0 0 0 1.71-2.99z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M246.76 327.59c-8.26 0-16.09-9.52-21.26-16.66l-.16-.22 2.11-36.88 1.19 4.73c0 .15 3.82 15 6.82 20.08 2.5 4.25 6.46 7.44 10.33 8.33a7.86 7.86 0 0 0 6.28-1c5.08-3.39 7.75-12.47 9.51-18.48.49-1.7.89-3.58 1.31-5.57 1.52-7.25 3.25-15.48 10.86-17.75a3 3 0 0 1 2.37.27 3.24 3.24 0 0 1 1.55 1.94 3.24 3.24 0 0 1-2.18 3.9 8 8 0 0 0-3 1.89c-.06.52-.14 1-.22 1.55l-.25 1.6c-2.5 15.78-5.34 33.67-13.68 45.07-3.51 4.79-7.4 7.2-11.58 7.2zm-19.92-17.32c5 6.85 12.4 15.8 19.9 15.82 3.67 0 7.15-2.21 10.34-6.56 8.13-11.12 10.93-28.81 13.41-44.43l.25-1.6c.09-.57.18-1.16.23-1.75v-.3l.33-.27a9.61 9.61 0 0 1 3.62-2.3 1.75 1.75 0 0 0 1.22-2.08 1.7 1.7 0 0 0-.83-1 1.55 1.55 0 0 0-1.22-.16c-6.75 2-8.31 9.45-9.82 16.63-.42 2-.82 3.93-1.33 5.68-2.42 8.23-5 15.9-10.12 19.31a9.36 9.36 0 0 1-7.45 1.19c-4.32-1-8.54-4.36-11.28-9-2.07-3.5-4.39-11.08-5.77-16l-1.48 26.82z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M75.44 524c-.17-1.73-2.9-1.75-2.73 0 .42 4.27 1 9.51-2.25 12.89-3.82 4-9.63 3-13.61-.1-1.39-1.08-2.75 1.29-1.38 2.36 4.6 3.54 11.13 4.41 15.89.61 4.76-3.8 4.64-10.26 4.08-15.76zm50.48 11.6c-3.27.21-7.92.15-10.3-2.49-2.38-2.64-3.14-6.91-2.82-10.27.16-1.75-2.57-1.74-2.74 0-.38 4.06.77 9.13 3.62 12.2 2.85 3.07 8.2 3.55 12.24 3.29 1.74-.11 1.76-2.84 0-2.73z"
          fill="#592C76"
          fillRule="nonzero"
        />
        <path
          d="M184.7 527.75c-.12-1.74-2.85-1.75-2.73 0 .27 3.9-.12 7.18-3.67 9.5a14.1 14.1 0 0 1-10.76 1.75c-1.71-.37-2.44 2.26-.72 2.64a16.83 16.83 0 0 0 13.55-2.47c3.92-2.9 4.63-6.8 4.33-11.42zm62.99-5.45c-1 5.83 1.23 12.2 6.56 15.22a12.86 12.86 0 0 0 15.51-2.32c1.21-1.28-.72-3.21-1.93-1.93a10.11 10.11 0 0 1-12.2 1.89c-4.21-2.36-6.08-7.52-5.3-12.13.29-1.72-2.34-2.46-2.64-.73z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M118.6 354.71c-9.49-.47-19-.93-28.46.28-4.51.57-9 1.53-13.46 2.06-7.76.92-15.61.57-23.42.21l-.44.12c.27 8.36 6.86 70.69 8.78 93.26 1.45 21.62 8.54 73.36 8.54 73.36l7.68-.32c.35-22.5 10.2-133.08 11.87-133.15 1.2 14.71 4.11 24 6.55 38.57 2.63 15.64 5.54 31 7.09 46.78.42 4.18 4.15 46.61 4.77 46.61l7 .47c1.6-1.95 2.59-34.3 2.75-66.21.27-9.4 2.89-92.82.75-102.04z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M118.6 353.7c-11.21-.54-22.28-.81-33.4 1a117.43 117.43 0 0 1-17.55 1.89c-2.84.05-5.69 0-8.53-.11-2-.07-4.58-.62-6.57-.09a1 1 0 0 0-.75 1c.3 8.78 1.45 17.58 2.3 26.32 1.36 14.05 2.77 28.09 4.14 42.13 2.41 24.66 4.53 46.31 7.49 70.91a2890.71 2890.71 0 0 0 3.39 27.23 1 1 0 0 0 1 1l7.68-.32a1 1 0 0 0 1-1c.31-18.24 2.14-33.52 3.62-51.7 1.77-21.92 3.63-43.85 6-65.72.39-3.6.79-7.2 1.28-10.79.15-1.06.29-2.13.5-3.19a3.36 3.36 0 0 0 .2-.93c-.09-.56.49-.1-.47.14l-1.3-1a217.18 217.18 0 0 0 4 25.2c1.92 9.35 3.5 18.76 5.1 28.17 2.21 13 4.06 26 5.2 39.11.85 9.89 1.69 16.77 2.63 26.65.35 3.63.67 7.26 1.14 10.87.3 2.27.41 2.9 2.9 3.07 1.52.1 4.13.81 5.6.35 1-.31 1.11-1.27 1.29-2.15a89.28 89.28 0 0 0 1.11-12.86c.85-16.45 1.06-30 1.19-46.42.14-17.06.89-34.13 1.24-51.19.22-10.79.4-21.58.42-32.36 0-7.32.2-14.74-.52-22a20.39 20.39 0 0 0-.35-2.47c-.28-1.26-2.26-.73-2 .54 1.21 5.44.74 11.54.78 17.07.08 9.91 0 19.83-.22 29.75a3442.46 3442.46 0 0 1-1.3 52.47c-.42 13.48-.29 24-.67 37.47-.18 6.75-.41 13.52-.82 20.27-.13 2.28-.29 4.56-.53 6.84-.08.68-.82 2.84-.57 3.42.07.17.67-.35.67-.35-.17-.13-.75 0-1-.07-1.1-.19-2.3-.15-3.42-.23a10.94 10.94 0 0 0-2.33-.15c-.14.2.6.73.78.52 0 0-.1-.38-.09-.44a14.18 14.18 0 0 0-.41-3.15 463.2 463.2 0 0 1-.54-5.23c-1-9.64-1.78-16.28-2.62-25.93-.86-10-1.85-20-3.36-29.92-1.45-9.53-3.14-19-4.76-28.52-1.41-8.31-3.35-16.52-4.79-24.83a153.36 153.36 0 0 1-1.72-13.47 1 1 0 0 0-1.3-1c-1.14.28-1.19 2.31-1.33 3.19-.43 2.63-.74 5.29-1 7.95-1.1 9.34-2 18.7-2.87 28.07-2.24 23.8-4.24 44.62-5.92 68.47-.61 8.8-1.31 17.62-1.46 26.44l1-1-7.68.32 1 1c-2.72-21-5.32-39-7.4-60.07-2.47-25-4.67-50-7.11-74.95-1-10.48-2.45-21-2.81-31.57l-.75 1c2.17-.58 5.36.15 7.62.21 2.84.08 5.69.11 8.53 0a114.68 114.68 0 0 0 15.46-1.76c11.3-1.89 22.49-1.68 33.89-1.12 1.39.1 1.39-1.91.07-1.98z"
          fill="#59E8E2"
          fillRule="nonzero"
        />
        <path d="M101 457.33s-.08-.01 0 0z" fill="#FFF" fillRule="nonzero" />
        <path
          d="M102 457.33a1 1 0 0 0-1.3-1 1 1 0 0 0 0 1.94 1 1 0 0 0 1.26-.71 1 1 0 0 0-.71-1.23v1.94l-1.3-1a1 1 0 1 0 2 0l.05.06z"
          fill="#59E8E2"
          fillRule="nonzero"
        />
        <path
          d="M148.6 280.7l-32.84-.41c-8.65-.11-17.84-.35-25-4.48a44 44 0 0 0-1.54 14.5l26.84 6c11.72 2.63 23.68 5.28 35.78 4.63a234.56 234.56 0 0 0-3.91-18 1.15 1.15 0 0 0-.58-.86c-.36-.15-.89.24-.63.5"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M148 301.81c-11 0-21.71-2.41-32.12-4.75l-27.39-6.15v-.56A44.34 44.34 0 0 1 90 275.61l.26-.93.84.48c7.22 4.17 16.87 4.29 24.62 4.38l32.85.41v1.5h-.81c.46.29.78.76.87 1.3 1.54 6 2.86 12.05 3.93 18.09l.15.83h-.85c-1.27.11-2.56.14-3.86.14zM89.94 289.7l26.28 5.9c11.27 2.53 22.92 5.14 34.73 4.65a222.1 222.1 0 0 0-3.75-17.14c-.07-.27-.12-.33-.14-.35.17.07.22 0 .26-.07a.55.55 0 0 0-.08-.66l-1.05 1.07a.94.94 0 0 1-.12-1.23 1.22 1.22 0 0 1 .51-.44l-30.83-.43c-7.64-.09-17.07-.21-24.51-4.11a43 43 0 0 0-1.3 12.81z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M118.25 272.73c-4.42-1.84-28.34-1.25-28.34-1.25s-3.16 5.76-9.39 5.76c-5.25 0-6.45-4.17-10.69-5.59-4.72-1.59-15.9 2.58-20.87 2.94-21.51 1.51-20.5 33.66-16.64 48.56 1.86 7.18 6.34 17.39 13.19 20.87.4.16.76.4 1.07.69 1.74 2 1.88 31.78 4.16 32 0 0 42.17 4.17 72.77-2.57 1.1-7.68 1.74-24.21 2.12-32 5.81-2.47 10.48-6.23 12.8-11.05 7-14.49-1-37-10.47-50.39a22 22 0 0 0-9.71-7.97z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M75.06 328.21c-5.61 2.27-7.71 1.48-8.3.33-1.59-2.71 3.1-6 6.1-6.87a24.49 24.49 0 0 1 6.67-.79"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M66.57 239.62a138 138 0 0 1-1.49-15.46c-.17-3.58.53-7.5 3.2-9.89 3.12-2.81 7.9-2.63 12-1.67s8.19 2.54 12.35 2a3.32 3.32 0 0 1 2.53.24c.81.63.72 1.86.55 2.88-1.53 9.22-3.48 18.59-2.71 28.13.24 3.07-2 3-2.31.29-.28-2.1.53-4.22.48-6.31a103.48 103.48 0 0 0-.82-10.7A76.17 76.17 0 0 1 69.12 233c0 1.7.26 15.2-1.35 14.88-2-.4-1-6.73-1.2-8.23"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M218 361.38c-9.49-.48-15.15-.95-24.57.28-4.51.59-8.95 1.57-13.46 2.11-7.76.93-15.61.57-23.42.21l-.44.12c1.58 51.48 13.27 102.43 22.24 152.93 1 5.43 1.94 12.45 1.94 12.45l6.56-.68c-.68-41.64 4.76-84.11 6.12-126 12.54 46.24 51.24 121.9 53.5 122.64l5.64-1.41c-6.2-28.31-30.75-162.49-34.11-162.65z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M193.54 274.57a6.32 6.32 0 0 1-2-2.58 8.48 8.48 0 0 1 0-4.39 88.65 88.65 0 0 1 4.16-15.27 3.72 3.72 0 1 0 1.82-6.65c.7-3.08 1.73-6.09 2.25-9.21a16.29 16.29 0 0 0-.78-9.31c-4-8.79-14.35-4.88-19 1-2.88 3.59-4.49 8-5.6 12.49a3.49 3.49 0 0 0-2.34 6 7 7 0 0 1 1.34 1.27c.17.31.29.65.35 1l2.82 12c.67 2.85 1.34 5.87.48 8.67-.86 2.8-3 4.82-5.3 6.55-6.58 5-14.76 8.15-19.79 14.7 4-1.1 8.2.86 11.32 3.56 3.12 2.7 5.51 6.14 8.59 8.88 3.08 2.74 7.25 4.79 11.25 3.82 2.75-.65 5-2.61 7-4.54 8-7.52 15.36-15.7 22.71-23.88a22.41 22.41 0 0 1-18.39-3.4c-.31-.28-.61-.47-.89-.71z"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#18E8E3"
          strokeWidth="1.5"
        />
        <path
          d="M50.65 272.22a14.21 14.21 0 0 0 3.35 6.14 4.86 4.86 0 0 0 1.7 1.29 2.14 2.14 0 0 0 2-.18 3.22 3.22 0 0 0 .87-2.57v-3.31a3.53 3.53 0 0 0-.26-1.41c-.59-1.21-2.2-1.38-3.54-1.39h-2.43a2.27 2.27 0 0 0-1.21.2.83.83 0 0 0-.4 1"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M56.59 280.57a3.1 3.1 0 0 1-1.18-.23 5.56 5.56 0 0 1-2-1.47 14.8 14.8 0 0 1-3.51-6.47h.13a1.57 1.57 0 0 1 .69-2.05 3.09 3.09 0 0 1 1.59-.3h2.42c.91 0 3.34 0 4.21 1.81a4.05 4.05 0 0 1 .34 1.71c0 1.11.06 2.24 0 3.35a3.83 3.83 0 0 1-1.17 3.15 2.58 2.58 0 0 1-1.52.5zM51.38 272a13.45 13.45 0 0 0 3.16 5.81c.39.5.89.91 1.46 1.19a1.38 1.38 0 0 0 1.31-.08 2.66 2.66 0 0 0 .58-2v-3.26a2.81 2.81 0 0 0-.18-1.11c-.32-.65-1.24-1-2.88-1H52.4a1.93 1.93 0 0 0-.83.1.19.19 0 0 0-.09.12l-1.26.61 1.16-.38z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M48.84 328.45c8.2 5.67 17.77 7.66 27.06 3.43a41.32 41.32 0 0 0 8.24-5.2c3.83-3 7.86-4 12.78-4a.4.4 0 1 0 0-.8c-4 0-8.32.46-11.62 2.91a74.5 74.5 0 0 1-6.9 4.93c-9.68 5.64-20.07 4.35-29.15-1.93-.43-.29-.84.41-.41.7v-.04zm-2.3 16.25c8.55 2.4 17.84 2.46 26.09-1.1a53 53 0 0 0 11.05-7c4-3.1 8.32-7.43 13.41-8.66.5-.12.29-.9-.22-.78-3.84.93-7 3.64-10.08 6a96.2 96.2 0 0 1-11.24 8c-8.82 5-19.19 5.37-28.8 2.69a.4.4 0 0 0-.21.77v.08z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M79.09 321.41c2.25.37 4.62.53 6.68 1.59.46.24.87-.46.41-.7-2.14-1.09-4.54-1.28-6.88-1.67-.51-.08-.73.69-.21.78zm46.06 20.47c-3.89 3-10.77 3.32-15.39 3.33a34.4 34.4 0 0 1-25-10.13c-.36-.37-.93.2-.57.57a35.11 35.11 0 0 0 25 10.36 42.53 42.53 0 0 0 10.48-1.15c2-.47 4.3-1 5.93-2.28.41-.31 0-1-.4-.7h-.05zm-15.65-12.72c8.31 2 20.34-6.69 16.77-15.84-.19-.48-1-.27-.78.22 3.33 8.5-8 16.73-15.78 14.85-.5-.13-.72.65-.21.77z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M100.17 328c2.38 1.3 7.08 1.92 7.38.28.3-1.64-2.21-4.72-4.55-6.06-2.08-1.2-4-1.13-6.64-.71"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M183.4 237.66a71.92 71.92 0 0 1-2.48 9 .56.56 0 0 0 .54.71 43.48 43.48 0 0 1 4.42-.1.56.56 0 0 0 0-1.12 40.76 40.76 0 0 0-4.42.1l.54.71a72.54 72.54 0 0 0 2.48-9c.14-.7-.94-1-1.08-.29v-.01z"
          fill="#6A25D6"
          fillRule="nonzero"
          stroke="#6A25D6"
          strokeWidth=".25"
        />
        <path
          d="M173.45 274.77c3.88 3.89 7.91 25.06 7.91 25.06l11.88-25.42c7.2-4.5 19.17-3.45 27-1.78 4.46.94 8.09 2.35 9.1 7.37 1.36 6.69-.68 13.9-1.2 20.53-.74 9.37-1.6 18.73-2.24 28.1-1.29 18.83-1.73 37.8.91 56.53-30.61 7.95-72.77 3-72.77 3-3.17-15.61-4.65-31.73-6.2-47.57-1.12-11.42-2-22.87-2.48-34.34-.31-7.57-1.47-15.22-.79-22.81.49-5.54.88-6.58 6.67-7.11 7.4-.67 14.81-.28 22.18-1.59"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M83.3 244.62c-.82-2.84-1.55-4.59-2.18-7.47-.16-.7-1.22-.4-1.07.29.58 2.65 1.25 4.17 2 6.77h-3.68a.55.55 0 1 0 0 1.1h4.4a.56.56 0 0 0 .53-.69z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M193.4 241.19a4.37 4.37 0 0 0-5.07-2c-.55.17-.32 1 .23.86a3.48 3.48 0 0 1 4.07 1.56.45.45 0 0 0 .77-.42zm-13-3.43a6.79 6.79 0 0 0-5.25-1.08c-.56.11-.33 1 .24.86a5.84 5.84 0 0 1 4.56 1c.47.32.91-.45.45-.78zm-104.27.87a6 6 0 0 0-4.7.39c-.45.24 0 .9.41.67a5.19 5.19 0 0 1 4.1-.3c.48.16.66-.6.19-.76zm12.58-.48a5.93 5.93 0 0 0-4.71-.07c-.47.19-.12.89.35.7a5.17 5.17 0 0 1 4.1.11c.46.2.72-.54.26-.74z"
          fill="#6A25D6"
          fillRule="nonzero"
          stroke="#6A25D6"
          strokeWidth=".75"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M187 251.35h-.08a14.94 14.94 0 0 1-7.7-1.15.51.51 0 0 0-.45 0 .56.56 0 0 0-.27.7.52.52 0 0 0 .3.32c1.31.57 2.64 1.28 1.93 1.27a.43.43 0 0 0-.42.21.59.59 0 0 0 0 .59.6.6 0 0 0 .51.31 17.41 17.41 0 0 0 2.18-.1 16.73 16.73 0 0 0 4.28-1.09.56.56 0 0 0-.26-1.07l-.02.01z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M90.93 271.1a.4.4 0 0 0-.53-.3.48.48 0 0 0-.4.59 107.5 107.5 0 0 1 2 10.66l-7-3.33c-.3-.14-.67-.35-1.08-.58-1.1-.62-2.63-1.49-3.55-1.43a6.18 6.18 0 0 0-2.79 1.4c-.39.27-.75.53-1.09.74a126.98 126.98 0 0 1-6.94 3.91v-10.21c0-.44-.39-.41-.49-.46a.44.44 0 0 0-.48.45l.19 11.9c2.16-1 4.23-2.21 6.17-3.34.37-.21.91-.59 1.52-1 2-1.36 3.34-2.25 4.13-2.25a23.7 23.7 0 0 1 3.54 1.61c.53.3 1 .58 1.33.73l7.54 3.62c0-.42-1.18-8.96-2.07-12.71z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M205.64 223.82c-1-2.28-3.16-3-5.36-3a3.94 3.94 0 0 0-2.29-1.6c-.22-1.32-2.52-2.47-3.85-2.4a12.5 12.5 0 0 0-3.91.85 1.93 1.93 0 0 0-.61-.45c-4.07-2-7.62 2.44-8.22 6.12a3.08 3.08 0 0 0 1.75 3.3c.57.28 1.28.11 1.79.34 1.39.62 2.38 2 3.77 2.72a17.68 17.68 0 0 0 4.73 1.58c3 .57 6.37.64 9.15-.69 2.58-1.22 4.34-3.92 3.05-6.77z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M494.7 223.12c-8.58 2.72-4.37 16.06 4.23 13.34 8.6-2.72 4.37-16.07-4.23-13.34z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M464.61 520.32a1.17 1.17 0 0 0-.85-.87 1.5 1.5 0 0 0-1.39.42 1.36 1.36 0 0 0-.33 1.35 9.25 9.25 0 0 1-14.4 10 1.34 1.34 0 0 0-1.37-.17 1.53 1.53 0 0 0-.89 1.15 1.2 1.2 0 0 0 .52 1.11 12.74 12.74 0 0 0 7.56 2.5 11.52 11.52 0 0 0 6.6-2 12.26 12.26 0 0 0 4.55-13.49z"
          fill="#592C76"
          fillRule="nonzero"
        />
        <path
          d="M348.35 258.86a5.22 5.22 0 0 0 1.19-7.63c-2.7-3-8.71-2.6-9.75-6.5a14.46 14.46 0 0 1 0-3.83c0-4.84-5.87-8.62-10.25-6.56-3.37 1.59-4.82 2.79-8.68 2.34-3.7-.44-6.23-3-9.84.32-6 5.56 3 10-1.33 14a20.65 20.65 0 0 1-7 4.08c-3 1.14-3.4 5.73-1.31 8.21 1.38 1.66 3.68 3.28 3 5.34-.39 1.22-1.69 1.85-2.65 2.71a5.88 5.88 0 0 0 4.8 10.2 7.52 7.52 0 0 1 2.2-.25c3.34.49 2.57 6.92 5.88 7.6 2.33.49 3.93-2.47 6.24-3 4.37-1 7.65 6.73 11.78 5 2.65-1.12 2.78-5.4 5.48-6.4 2.7-1 5.46 2.15 8.3 1.63a4.37 4.37 0 0 0 3.19-4.16 9.46 9.46 0 0 0-1.71-5.29 5.09 5.09 0 0 1-1-2.41c-.07-2.41 3.1-3.25 5.48-3.64 2.38-.39 5.32-2.55 4-4.56a3.24 3.24 0 0 0-1.39-1.06c-1.91-.88-4.15-1.13-5.76-2.49-1.61-1.36-1.59-2.83-.42-3.94"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M470.17 252.19c-1.93-1-3.94-2.09-5.2-3.88-1.26-1.79-1.48-4.5.1-6 1.37-1.31 3.62-1.33 5-2.65a8.86 8.86 0 0 0 1.65-3 16.35 16.35 0 0 1 31.28 6.08c.07 2.14-.26 4.41.7 6.32 1 2.1 3.37 3.21 5 4.89 3.12 3.2 3.5 8.16 3 12.61-.45 4.21-1.88 9-1 13.26.75 3.58 4.21 5.17 5.59 8.48a16.3 16.3 0 0 1 1 8.11c-2.58 11.89-19.39 2.89-23.75-3.09a78.4 78.4 0 0 1-11.38-20.92c-2.59-7.62-4.92-15.55-12-20.21"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M464.84 299.92c3.46 2 8.86 1.64 12.66 1.69 3.47 0 7 .08 10.46-.17 1.77-.13 3.61-.34 5.45-.65 3.82-3.76 7.64-7.89 10.82-11.19a78.73 78.73 0 0 1-6.1-2.75 3.3 3.3 0 0 1-1.5-4.22 17.5 17.5 0 0 1-4.2-2.86c-4.12-4.29-5.7-8.34-3.43-14.46l-17.19-5c2.24 8.32 4.29 18.13.16 23.47-3 3.82-7.57 5.3-12.25 6.73 2.28 2.79 2.28 7.75 5.12 9.41zm7.89 9.01l-2.32-.21a17 17 0 0 0 10.14 2.36 12.12 12.12 0 0 0 4.83-1.85 113.45 113.45 0 0 1-12.65-.3z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M497.52 254.17a3.17 3.17 0 0 0-4.52-.94 38.65 38.65 0 0 0-.09-4.69 31.84 31.84 0 0 0-2.08-9.61 10.94 10.94 0 0 0-3.74-5.09 5.52 5.52 0 0 0-6-.32c-3.26.77-5.79 3.64-7.4 6.66a26.58 26.58 0 0 0-1.92 20.16c1.95 6.31 7.27 11.44 14.19 7.7 3.1-1.67 4.95-5.71 6-9.05 0-.06 0-.13.05-.19a4.12 4.12 0 0 0 4.22 0 3.61 3.61 0 0 0 1.29-4.63z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M358.94 393.31c7.91 13.13 19.43 32 25.33 46.17 1.21 2.89 2.39 5.88 2.46 9 .07 3.12-1 6.38-2.15 9.43-7.9 21.57-15.36 49.41-24.29 70.58-.7 1.66-4 3.8-5.36 2.67-.84-.67-.55-1.93-.49-3 1.52-27.12 6.07-56.43 13.94-71.22a6.11 6.11 0 0 0 .37-3.74 10.64 10.64 0 0 0-2.32-4.51c-9.5-13-25.29-36.64-29.25-52.25"
          fill="#46204F"
          fillRule="nonzero"
        />
        <path
          d="M341.37 288.6c-1.23-2.48-2.76-8.13-.83-10.38 3.13-3.66 2.25-9.33 1.71-13.7A27.58 27.58 0 0 0 336 250c-2.29-2.69-5.47-5-8.93-5.1a5.71 5.71 0 0 0-5.94 1.63 11.32 11.32 0 0 0-2.66 6 32.6 32.6 0 0 0 0 10.15 38.36 38.36 0 0 0 .94 4.75 3.29 3.29 0 0 0-4.36 1.94 3.72 3.72 0 0 0 2.25 4.41 4.27 4.27 0 0 0 4.26-.93l.09.18c.92 1.59 2.63 2.53 3.6 4.09 5.51 8.88-2.85 16.39-9.54 21-.2.14-.42.31-.43.56.01.18.08.35.21.48 2.74 3.82 2.69 8.33 7 10.77 4.59 2.59 10.57 2.86 15.69 3 10.93.4 3.57-15.23 14.49-14.64-5.67-.38-9.06-5.16-11.3-9.69z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M482.09 379.87c.12-1.31 2.17-1.32 2.05 0-1 10.64-9.74 61.13-10.76 71.77-1 10.43-8 71.24-10 71.34-1.15.06-9.15-51.14-9.18-73.51 0-11.45 1.15-22.9 1.35-34.35.24-14.85 7.91-28.73 8.28-43.57 0-.6.65-1.26 1.29-1 7 2.86 6.45 9.91 14.38 10.22l2.59-.9z"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#59E8E2"
          strokeWidth="2"
        />
        <path
          d="M338.74 245.6c2.29 3.65-.23 8-3.16 10.34a31 31 0 0 1-7.3 4l-10.43 4.54a9.36 9.36 0 0 0-2.43 1.36 3.14 3.14 0 0 0-1.18 2.43c-1.58-6-1.78-12.81 1.45-18.15a18.47 18.47 0 0 1 14.31-8.38c3.33-.27 7.19.52 8.7 3.86"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M319.1 273c.21-.53-.59-.92-.8-.38a78.72 78.72 0 0 0-2.82 8.78.45.45 0 0 0 .48.52c2.15-.23 4.31-.43 6.47-.59a.46.46 0 0 0 .32-.7c-1.57-2.49-3.09-5-3.41-8a.45.45 0 0 0-.89.09m25-.81s.06-1.48.72-1l6 4.15a.64.64 0 0 1-.11 1.09c-2 1.04-4.02 2.07-6.05 3.1a.64.64 0 0 1-.87-.66l.31-6.68z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M314.76 295.91c-2.8.76-6 1.6-7.53 4.36a16.2 16.2 0 0 0-1.49 5.62c-.66 4.95-1.12 9.92-1.58 14.88-2.26 24.68-4.23 49.5-2.61 74.23a380.49 380.49 0 0 0 65.45.69 2.53 2.53 0 0 0 2.12-.89 2.48 2.48 0 0 0 .14-1.55l-11.54-94.52a5.43 5.43 0 0 0-1-3.08 3.76 3.76 0 0 0-3.73-.85 27.29 27.29 0 0 1-17.22 7c-10.53.31-21.01-5.89-21.01-5.89z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M306.76 373.77c-.93 0-2.07 1.09-2.74 1.53l-6.86 4.53-14.48 9.55a1.46 1.46 0 0 0-.36 1.73c.79 1.68 8.34 15.85 11.66 20.53a1.49 1.49 0 0 0 2.06.15c7.81-6.52 17.83-9.71 25-17.08a1.5 1.5 0 0 0 .36-1.73 90.48 90.48 0 0 0-8.06-12.76c-1.44-1.87-3.85-6.52-6.58-6.45z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M308.68 384.75c-1.6 1.06-3.16 2.16-4.71 3.3a31.87 31.87 0 0 0-2.38-2.1c-1.47-1.16-3 1.32-1.55 2.47.55.44 1.09.9 1.61 1.38a119.07 119.07 0 0 0-8.22 7 1.46 1.46 0 0 0 2 2.13 109.77 109.77 0 0 1 8.26-7 25.89 25.89 0 0 1 2.11 2.68c1 1.54 3.63.17 2.57-1.38a34.08 34.08 0 0 0-2.38-3 99.18 99.18 0 0 1 4.09-2.85c1.54-1.09.17-3.67-1.4-2.63z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M294.67 353.82c.83-4.14 3.19-8.23 5.23-11.95a32.88 32.88 0 0 1 3.8-5l2.59-34.87c-21.77 26.25-27.86 58.14-14.72 89.65 1.73 4.17 5 8.87 9.47 8.24a1.17 1.17 0 0 0 .74-.3c.41-.46.06-1.17-.3-1.67-8.59-12.39-9.69-29.87-6.81-44.1z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M326 373.23a9.78 9.78 0 1 1-6.71-10.41 9.89 9.89 0 0 1 6.71 10.41c0 .61.89.6.94 0a10.72 10.72 0 1 0-9.6 9.57 10.81 10.81 0 0 0 9.6-9.57c.06-.59-.85-.59-.94 0z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M365.55 354.55a4.05 4.05 0 1 1-3.57-4.48 4.1 4.1 0 0 1 3.57 4.48c0 .25.37.25.39 0a4.44 4.44 0 1 0-3.94 4 4.49 4.49 0 0 0 3.94-4c.06-.24-.35-.24-.39 0z"
          fill="#F7F8F9"
          fillRule="nonzero"
        />
        <path
          d="M318.25 308.79c-3.46-4-7.54-4.92-12.33-5.59.07.24.1.48.12.73 3.69.46 7.36 1.07 10.16 3.78a15 15 0 0 1 3.8 16.72c-2.22 6-9.38 9.44-15.85 9 .06.24.08.48.07.72 6.41.43 13.41-2.77 16.07-8.49a15.53 15.53 0 0 0-2.04-16.87zm15.48-6.98c-2.55 3.93-1.24 9.6 1.53 13.08a12.53 12.53 0 0 0 13.64 4c10.12-3.37 10.68-17.37 1.39-22-.43-.21-.8.43-.37.64 8.68 4.36 8.33 17.5-1.21 20.69a11.88 11.88 0 0 1-12.14-2.9c-3.12-3.23-4.79-9.1-2.2-13.1.26-.4-.38-.77-.64-.37v-.04zM331 334.34a7.06 7.06 0 0 0-2.69 8.92c1.8 3.65 5.92 5.25 9.5 3.07a6.9 6.9 0 0 0 2.4-9.35 7 7 0 0 0-9.91-2.22c-.4.25 0 .89.37.64 2.85-1.76 6.85-1.38 8.73 1.65a6.21 6.21 0 0 1-2 8.64c-6.82 4.13-12.5-6.55-6.06-10.71.39-.26 0-.9-.38-.64h.04zm37.73 38.29a14 14 0 0 0-18.27 2.52c-5.39 6.2-4.86 15.24.46 21.3.31.35.83-.17.52-.53a15.36 15.36 0 0 1-.45-20.25 13.29 13.29 0 0 1 17.87-2.05 4.07 4.07 0 0 1-.13-.99zm-10.25-22.05a4.72 4.72 0 1 0 6.47 6.86c4.14-4.22-2.15-11.11-6.47-6.86-.33.33.19.86.53.52 3.67-3.62 8.84 2.28 5.42 5.81a4 4 0 1 1-5.43-5.81c.35-.32-.18-.84-.53-.52h.01z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M330.75 263.55a.94.94 0 0 0 .73-.11.82.82 0 0 0 .35-.52.57.57 0 0 0-.05-.41.71.71 0 0 0-.52-.32 8 8 0 0 0-1.65-.21 3.3 3.3 0 0 0-1.34.25 2 2 0 0 0-1.31 1.69.41.41 0 0 0 .12.33c.2.2.46.32.74.33a.8.8 0 0 0 .77-.46v-.07l.1-.22a.54.54 0 0 1 .36-.31c.1-.04.19-.07.29-.08a3.35 3.35 0 0 1 1.23.11h.18zm12.49-2.83a.71.71 0 0 0-.45-.41 8.23 8.23 0 0 0-1.6-.47 3.3 3.3 0 0 0-1.37 0 2 2 0 0 0-1.57 1.45.44.44 0 0 0 .07.34c.16.24.4.4.68.46a.79.79 0 0 0 .83-.33v-.07l.13-.2a.54.54 0 0 1 .4-.25h.31a3.37 3.37 0 0 1 1.2.31l.16.06a.88.88 0 0 0 1.17-.45.58.58 0 0 0 .04-.44zm-8.43 7.92c.91-.11 1.83-.17 2.75-.18a.83.83 0 0 0 .79-1l-2.17-6.77c-.32-1-1.9-.57-1.57.44l1.85 5.78c-.55 0-1.1.07-1.65.14-1.03.09-1.04 1.72 0 1.59zm-2.63 5.36a6.21 6.21 0 0 0 4.15.49c1.74-.38 1-2.55-.75-2.17a2.8 2.8 0 0 1-2-.26c-1.53-.8-2.94 1.15-1.42 1.94h.02z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M568.81 570.53c1.06.06 2.11.06 3.17 0 .84-.06.85-1.37 0-1.31a30.48 30.48 0 0 1-3.17 0c-.85 0-.85 1.28 0 1.31zm5.75.18a6.29 6.29 0 0 1 2 1.22c.63.56 1.56-.36.93-.93a8.17 8.17 0 0 0-2.61-1.56c-.8-.29-1.14 1-.35 1.27h.03zm27.15-.21c4-.62 8.16-.3 12.23-.8.82-.1.83-1.42 0-1.31-4.19.51-8.41.2-12.58.84-.83.13-.48 1.39.35 1.27z"
          fill="#F7F8F9"
          fillRule="nonzero"
        />
        <path
          d="M609.59 275.91c-2.93-3.33-2.4-8-2-12 .4-4 2.83-7.15 3-11.49.28-9.73-1-26-14.27-25.64-11.42.3-11.62 13.11-9.32 21.94a3.32 3.32 0 0 0-3.29 2.48 3.71 3.71 0 0 0 2.63 4.15 4.08 4.08 0 0 0 3-.44c1.28-.71 4.3 11 4.27 12.3-.1 4.92-1.94 10.76-5.78 14-2.66 2.24-11.58 5.7-14.93 3.51 5.84 3.82 25.44 24.32 32.4 23.88 13-.81 14.07-20.58 27-18.84-6.55-6.53-16.62-6.93-22.71-13.85z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M634.26 370c.13-4.59-1.87-8.36-3-14.28-8.5-.42-17-.85-25.47.26-4 .53-8 1.4-12 1.88-6.85.83-13.79.53-20.68.21.14 2.83-.53 5.9-.17 9 .08 14.06 2.35 36.52 2.29 49.61C575 448.6 584 528 584 528l5.75.26c3.25-47.8 7.82-96.66 11.25-144.54 2.34-.06 4.67-.16 7-.29 4.33 47.35 9.18 94.41 13.48 141.77l5 .47c2.23-2.78 6.44-105.21 6.44-105.21-.39-13.64 1.68-36.59 1.34-50.46zm-61.46-11.91h.27c0-.39 0-.78-.05-1.16l-.22 1.16z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M590 279.48c2.11 3.93 7.59 7 11.27 7 4.74 0 9.25-7.35 9.25-7.35l21 1.3 2.79 89.26c-23.32 6.43-61.45 2.45-61.45 2.45-1.59-8.3-6.15-51.35-5.83-79.63.06-6 3.42-10.83 7.58-11a90.93 90.93 0 0 0 15.39-2"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M589.5 279.8c2.48 4 7.9 8.1 12.9 7.17a10.44 10.44 0 0 0 5-3c.82-.77 3.17-4.25 3.45-4.38-.12.06 2.35.26 3 .31l8.2.5 6.59.41c1.53.1 2.86.7 2.31-.38.49 1 .1 3.29.14 4.34l.31 9.92.93 29.81.94 30 .32 10.22c0 .78.65 4.1.15 4.74-.34.43-6 1-7.06 1.18a128.32 128.32 0 0 1-12.8 1.5c-7.15.51-14.32.59-21.48.41a289.8 289.8 0 0 1-15.86-.81c-.74-.06-2.58.13-3.23-.29a25.28 25.28 0 0 0-.31-2.72c-2.15-14.71-3.3-29.63-4.25-44.45-.58-9.05-1-18.11-1.06-27.18 0-6.44 0-13.79 7.92-15.06 4.86-.79 9.74-1.11 14.61-2 .79-.15.45-1.36-.33-1.21-3.82.72-7.65 1.46-11.52 1.81-2.05.18-4.2-.05-6.12.79-3.52 1.53-5.23 5.68-5.68 9.24-1.28 10.11.18 21.24.79 31.38 1 16.65 1.91 33.75 4.94 50.19a.65.65 0 0 0 .61.45c20.11 2.08 42 2.75 61.62-2.47a.62.62 0 0 0 .46-.6l-2.45-78.19-.34-11.07a.65.65 0 0 0-.63-.63l-21-1.3a.63.63 0 0 0-.54.31 17.87 17.87 0 0 1-5.59 6c-5 2.86-11.17-1.31-13.85-5.59-.42-.68-1.51-.06-1.08.63l-.01.02z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M647 281.34a1 1 0 0 0-1.19-.85c-3.44.62-13.31.63-14.86-.38h-.19c-1.19 6.43.11 13.31 0 19.76 4.16-.17 18.08-2.16 17.95-3-.71-4.36-1.11-10.87-1.71-15.53z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M593.66 248.2c.71-.86 2.19-1.43 3.09-.72.9.71 1.82-.47 1.06-1.06a3.8 3.8 0 0 0-5.21.72c-.61.74.45 1.81 1.06 1.06zm11.51-2.71c.32-.52 1.56-1.05 2.14-.45.58.6 1.73-.37 1.06-1.06-1.23-1.28-3.6-.7-4.49.75-.51.82.78 1.58 1.29.76z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M580.38 319.43c17.32 19 49 31.1 74.56 23.33 3.08-.94 6.15-.56 9.25-1.34 4.53-1.15 1.16-3.49-1.42-3.9-4.68-.75-10.45 2.66-15.49 2.71-28.54.26-47.36-13.69-65.09-34.56"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M569.79 286.14c.37-8.53-4.85 11.16-3.57 19.6 1.28 8.44 11.61 18.87 18.88 23.34 4.81-6.83 5.32-16.56 5.32-16.56s-21.05-16.77-20.63-26.38z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M462.32 320.66c.1-13.53-5.29-21-5.19-34.53 0-2.78-4.83-1.45-5.42 1.34-2.15 10.15-10 30.61-12.84 37.73a3 3 0 0 0 1.41 3.75c2.62 1.36 6.78 3.52 9.32 4.87a3 3 0 0 0 3.83-.87c2.74-3.75 4-6.62 8.16-10a2 2 0 0 0 .73-2.29z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M388.57 23.9a5.43 5.43 0 0 1 2.43 2.64c-2.67 2.33-3.6 6.42-7.52 7.5-.66 2.76-4.56 2.85-4.88 5.9a.76.76 0 0 1-.38.5c-3.59 1.87-5.38 5.58-8.17 8.26-2.79 2.68-5.72 5.75-8.56 8.66-1.8 1.84-4.43 3.18-3.85 6.45a2.7 2.7 0 0 1-1.55.33c-3.16-.5-4.54 1-4.62 4-4 3-6.9 7.31-11.48 9.62a2.42 2.42 0 0 1-2.35-2.09 4.45 4.45 0 0 1 1.43-3.47c2.89-2.7 5.39-5.78 8.45-8.31 2-1.68 3.48-3.95 5.25-5.91a99.4 99.4 0 0 1 11.74-10.83c1.73-1.14 2.74-2.92 4-4.49a167 167 0 0 1 18-18.43 1.62 1.62 0 0 1 2.06-.33z"
          fill="#996CEB"
          fillRule="nonzero"
        />
        <path
          d="M379.42 84.15a12.93 12.93 0 0 1-1.32 6.38c-.81.75.56-1.64-1.25-.72-2.68 1.37-3.36 4.1-5.4 5.75a53.08 53.08 0 0 0-6.69 6.8c-3 3.54-6.84 6.36-10.11 9.71-1.6 1.64-2.94 3.58-4.83 4.93-1.17.82-2.52.58-3.81.63-.43.2-.91.26-1.38.17-2.14-1.76-.5-3.2.64-4.23 6.91-6.24 12.8-13.52 19.78-19.62 3.86-3.37 6.82-7.47 10.63-10.81 1-.84 2-1.83 3.4-1.24 1 .43.61 1.43.34 2.25z"
          fill="#7377E7"
          fillRule="nonzero"
        />
        <path
          d="M379.42 84.15c.06-2.47-1.49-2.28-2.49-1.05-1.82 2.23-4.7 3.56-5.81 6.28-1.39 3.38-5 4.08-7.2 6.62-4.76 5.51-10.23 10.41-15.29 15.68-.52.54-1.13.78-1.57 1.23-1.26 1.27-3.45 2.13-2.55 4.62-1.46.71-3 .17-4.53.34-1.09-.13-1.09-.87-.84-1.65a7.69 7.69 0 0 1 2.08-2.79c9.78-10.3 20.17-20 29.7-30.56a64.7 64.7 0 0 1 5.64-5.19c1.75-1.51 2.84-1.11 3.33 1.12.03 1.8.43 3.63-.47 5.35z"
          fill="#7776E8"
          fillRule="nonzero"
        />
        <path
          d="M358 63.52c-2-1.88-1.62-2.39.44-4a40.89 40.89 0 0 0 3.31-3.38c4.25-4.31 8.86-8.35 12.52-13.12 1-1.31 2.19-1.7 3.17-2.64.37-.36.95-.84.92-1.22-.15-1.85.28-3 2.46-2.87.29 0 1.73-.43 1.22-1.43-.74-1.46.35-1.25 1.09-1.55 2-.81 4-1.37 4.38-4.22.16-1.28 2.17-1.88 3.51-2.53a7.83 7.83 0 0 1 1.79 5.78c-1.41-.56-2.1.47-2.94 1.27-3.58 3.41-6.52 7.46-10.46 10.49a21.8 21.8 0 0 0-6.78 4c-1.6 1.52-2.87 3.15-2.24 5.56-3.54 4.31-6.76 9-12.26 11.12a.92.92 0 0 1-.13-1.26z"
          fill="#946EEA"
          fillRule="nonzero"
        />
        <path
          d="M302.77 76.18a26.63 26.63 0 0 1 1.8-9 37.46 37.46 0 0 0 7.56-6.86c5.65-6.56 12.25-12.14 18.15-18.43a23.28 23.28 0 0 1 9.66-1.69c-.76 1.88-2.9 1.83-4.22 3.07-6.75 6.3-12.49 13.58-19.31 19.77-4 3.61-7.26 7.86-11.19 11.48-.83.55-1.22 1.67-2.45 1.66z"
          fill="#B964EE"
          fillRule="nonzero"
        />
        <path
          d="M379.89 78.8c-.84-1.42-1.53-2-3.05-.43-5.3 5.33-10.38 10.91-15.74 16.15-4.85 4.74-9.52 9.68-14.38 14.42-2.65 2.58-6.05 4.78-7.37 8.6a3.21 3.21 0 0 1-2.79.08l-1.08-.09c-.47-1.08-.37-2 .84-2.47 2.73-.57 3.48-3.15 5-5a4.22 4.22 0 0 1 .55-.64c1-.91 2.49-1.25 3-2.68a2.56 2.56 0 0 1 1.5-1.4c.85-.21 1.46-.59 1.17-1.63.12-.44.42-.8.83-1a47.4 47.4 0 0 0 7.93-7.64c.29-.49.71-.88 1-1.39a7 7 0 0 1 .65-1.12C362.72 87.29 368 82.34 372.73 77c1.61-1.82 3.49-2.93 5.16-4.47.42-.39.87-.59 1.38-.14a17.19 17.19 0 0 1 .62 6.41z"
          fill="#7A75E8"
          fillRule="nonzero"
        />
        <path
          d="M304.49 74.31c4.4-4.5 8.83-9 13.19-13.5 4.61-4.8 9.09-9.72 13.73-14.49 2.45-2.53 4.82-5.26 8.53-6.07 2.21-.07 4.45-.53 6.59.46a1.66 1.66 0 0 1-.71.57c-3.89-.15-6.21 2-8.76 4.81-3.83 4.14-8 8-11.73 12.28a88 88 0 0 1-8.26 8.73 155.18 155.18 0 0 0-11.5 11.44 1.82 1.82 0 0 1-2.28.56c-1.29-2.03.95-3.1 1.2-4.79z"
          fill="#B665EE"
          fillRule="nonzero"
        />
        <path
          d="M352.39 42a6.68 6.68 0 0 1 3.75 1.32c.3 1.06-.68 1.17-1.21 1.59-1.93 1.55-4.72 2.29-5 5.39-4.53 2.39-6.76 7.3-10.7 10.07-2.34 1.64-2.67 4.29-4.86 5.77-1.35.92-2.56 1.87-4.23 2a2.76 2.76 0 0 1-2.25-2.14c.27-2.92 2.43-4.83 4.26-6.56 5.58-5.23 10.81-10.8 16.33-16.08 1.13-1.08 2.18-2.13 3.91-1.36z"
          fill="#A968EC"
          fillRule="nonzero"
        />
        <path
          d="M336.12 115.62l-.64 1.91a10.84 10.84 0 0 1-5.21-1.17c-.87-1.38.16-2.26 1-3 7-6.55 13.65-13.47 20.31-20.36a4.15 4.15 0 0 1 2.4-1.51c1.81.23 2.89 1.54 4.06 2.72-.19.61-.68.75-1.24.78-2.46 3.12-5.86 5.32-8.39 8.39l-.64.64c0 .91-.75 1.37-1.29 1.94a2.17 2.17 0 0 0-1.29 1.29 79.3 79.3 0 0 1-3.23 2.58c-1.72 2.17-3.39 4.37-5.84 5.79z"
          fill="#8074E8"
          fillRule="nonzero"
        />
        <path
          d="M324.51 114.18a10.14 10.14 0 0 1-3.95-2.26.8.8 0 0 1-.21-.54c0-.2.02-.3.06-.3a358.7 358.7 0 0 0 15.5-15.94 5.35 5.35 0 0 0 1.17-1.9 1.73 1.73 0 0 1 .61-.65c3.2-1 4.54-4.19 7.17-5.89.94-.61 1.6-1.65 2.88-1.68 1.12.32 2.06.81 2.14 2.15-1.69 4-5.11 6.45-8.06 9.38-5.82 5.8-11.82 11.52-17.31 17.63z"
          fill="#8971E9"
          fillRule="nonzero"
        />
        <path
          d="M330.26 68c1.28-1.28 3.25-1.46 4.39-3.24.48-.75 1.21-.71.58-1.9-.54-1 .84-1.19 1.39-1.75 1.27-1.28 4.87-.57 3.54-4.08 2.72.44 2.47-3 3.66-3.24 2.37-.41 2.26-4.26 5.2-3.27.09 0 .52-.47.51-.72-.09-4.52 4.41-4.35 6.61-6.51a8.15 8.15 0 0 1 3.93 1.94c-4.42 3.15-8 7.23-11.77 11-1.71 1.72-3.78 3-5.36 5a75.21 75.21 0 0 1-9.27 10c-2.07-.09-3.11-1.23-3.41-3.23z"
          fill="#A469EC"
          fillRule="nonzero"
        />
        <path
          d="M352.39 42a3.74 3.74 0 0 0-3 1.51c-2.68 2.67-5.85 5-8.15 7.87-4 4.9-9.49 8.32-12.78 13.79a3.14 3.14 0 0 0-.19.94c-1.71 0-2.43-1.29-3.1-2.58a3.11 3.11 0 0 1 1.29-3.92c3.74-2.86 6.65-6.49 9.86-9.86 3-3.11 5.7-6.6 9.44-8.94l.73-.09a11.67 11.67 0 0 1 5.9 1.28z"
          fill="#AD67ED"
          fillRule="nonzero"
        />
        <path
          d="M349.82 117c1.22-2.17 3.2-3.83 4.57-5.69 3.27-4.45 8.62-6.63 11.39-11.43a11.9 11.9 0 0 1 3-3c1.61-1.31 3.74-2.45 4.31-5 .47-2 2.8-2.11 4.39-2.75.82-.33.42.91.62 1.42a7.13 7.13 0 0 1-1.33 3.77 28.56 28.56 0 0 0-4.65 5.17 22.21 22.21 0 0 1-5.16 5.17c-3.67 2.75-6.17 6.67-9.52 9.75a22.17 22.17 0 0 1-7.62 2.59z"
          fill="#6F78E7"
          fillRule="nonzero"
        />
        <path
          d="M333.5 71.21c1-2 2.1-4.17 4.19-5 2.09-.83 2.4-2.92 3.39-4.19 2.1-2.7 5.42-4.07 7-7.11.66-1.26 2.22-1.19 3-2.3 1.42-2.12 3.93-3.19 5.19-5.58a3.56 3.56 0 0 1 3.85-1.78l1.88 1.17c.13 1.88-1.74 2.28-2.66 3.21-4 4-7.71 8.21-11.91 12a83.56 83.56 0 0 0-11.19 12.17 2.45 2.45 0 0 1-2.74-2.59z"
          fill="#A06AEC"
          fillRule="nonzero"
        />
        <path
          d="M379.27 72.38c-1.09 1.18-2.12 2.43-3.94 2.42-.3 0-.83 0-.86.11-1.39 5.08-6.42 7-9.28 10.77a61.17 61.17 0 0 1-7.13 7.32c-1.3-1.53-.86-3.29-.69-5a9.05 9.05 0 0 1 3-4.09 100.86 100.86 0 0 0 11.27-11.71c1.44-1.74 4-2.46 4.59-5 .61-.81 1.2-1 1.75 0a13.06 13.06 0 0 1 1.29 5.18z"
          fill="#8074E8"
          fillRule="nonzero"
        />
        <path
          d="M324.51 114.18a12.84 12.84 0 0 1 4.45-6.11c6.28-5.22 11.09-12 17.71-16.82 1.3-1 .83-3.6 3.09-4 1.44-.1 2 .72 2.09 2-1.72 4-4 7.38-8.24 9.24a7.36 7.36 0 0 0-3.5 3.65 6 6 0 0 1-2.85 3.31c-.7.3-1 .58-.75 1.39a1.17 1.17 0 0 1-.53 1.41c-3.77 1.28-5.07 5-7.63 7.5a7.92 7.92 0 0 1-3.84-1.57z"
          fill="#8572E8"
          fillRule="nonzero"
        />
        <path
          d="M304.47 90.52a13.49 13.49 0 0 1-1.34-6.46l.12-.43c2.91-2.31 5.13-5.27 7.67-7.93 3.89-4.08 8.17-7.76 12.1-11.81.52-.52 1.13-1 2-.44 1.3 1.58 1.16 3.35.7 5.16a115.68 115.68 0 0 0-11.49 11.93 29.08 29.08 0 0 1-6.63 6.37c-1.5.93-1.6 2.83-3.13 3.61z"
          fill="#AD67ED"
          fillRule="nonzero"
        />
        <path
          d="M304.47 90.52c.67-4.24 4.77-5.69 7.18-8.49a36.09 36.09 0 0 1 3.52-4.03c3.28-2.78 5.44-6.62 9-9.1.15-.1.57.18.87.28 1.49 1.5 1 3.29.77 5-3.19 2.82-5.81 6.1-9.17 8.82-3.95 3.21-7.63 6.71-9.41 11.7a2 2 0 0 1-.81 1 10.19 10.19 0 0 1-1.95-5.18z"
          fill="#A969EC"
          fillRule="nonzero"
        />
        <path
          d="M336.09 73.76a11.52 11.52 0 0 1 3.3-5C345 63.19 350.59 57.54 356.2 52c1.9-1.89 3.27-4.33 5.81-5.53l2.5.75c-1.9 3.29-5.09 5.38-7.78 7.87-2.51 2.34-4.62 5-7.06 7.38-2.8 2.74-5.49 5.58-8.28 8.32a12.87 12.87 0 0 0-3.39 4.89c-1.32.08-2-.58-1.91-1.92z"
          fill="#9D6CEC"
          fillRule="nonzero"
        />
        <path
          d="M330.28 41.94c-.46 3-3.27 4.08-5 6-5.81 6.3-11.91 12.33-18 18.39-.65.65-1.46 1.75-2.75.94a21.74 21.74 0 0 1 3.86-8.38c3.31-1.17 5-4.24 7.18-6.59a82.59 82.59 0 0 1 9.52-8.35 11 11 0 0 1 5.19-2.01z"
          fill="#BC63EE"
          fillRule="nonzero"
        />
        <path
          d="M328.35 115.71c1.51-3.19 2.7-6.66 6.78-7.56.28-.06.74-.46.71-.53-1-2.47 1.61-2.61 2.43-3.9 1-1.53 1.51-3.3 3.07-4.54a28.17 28.17 0 0 1 3.4-2.08c2.28-1.35 3.94-3.64 5.41-5.9.45-.69.51-1.63 1.39-2 1.53.19 2.83.61 2.6 2.58-3.7 3.16-6.69 7-10.13 10.38-3.44 3.38-6.85 6.86-10.48 10.07-1.31 1.17-3 2.13-3.26 4.17a2.39 2.39 0 0 1-1.92-.69z"
          fill="#8373E8"
          fillRule="nonzero"
        />
        <path
          d="M388.57 23.9c-2.33 1.31-4.07 3.33-6.06 5-5 4.27-8.58 9.93-14 13.74 1.62-2.56 1.81-5.55 2.5-8.39 1.53-4.06 5.66-5.71 8.24-8.82.77-.94 2-1.57 2.63-2.73a1.91 1.91 0 0 1 2.76-.75c1.36.52 2.97.6 3.93 1.95z"
          fill="#9D6CEC"
          fillRule="nonzero"
        />
        <path
          d="M306.42 95.63c.75-4.27 3.44-7.27 6.32-10.3 2.41-2.53 5.49-4.25 7.79-6.67 1.41-1.49 1.85-3.77 4.5-3.7 1.12.9.91 2.1.76 3.29-1.1 2.94-3.83 4.58-5.85 6.66-3.79 3.9-7.77 7.63-11.48 11.63a1.11 1.11 0 0 1-1.42.38 1.42 1.42 0 0 1-.62-1.29z"
          fill="#A469EC"
          fillRule="nonzero"
        />
        <path
          d="M374.85 60.11a7.76 7.76 0 0 1 1.9 3.87c-5.51 4.56-10.1 10-15.06 15.13-1.16 1.19-2.17 2.84-4.13 1.16a6.46 6.46 0 0 1 .05-4.38c4.17-3.44 6.55-8.65 11.23-11.52 2.16-1.3 3.16-4.07 6.01-4.26z"
          fill="#8772E8"
          fillRule="nonzero"
        />
        <path
          d="M310.76 102.81a8.94 8.94 0 0 1-2.61-3.87c.7-2.5 3.39-3.24 4.65-5.16 2.41-3.68 6.3-5.93 8.75-9.59 1.5-2.25 2.73-2 4.22.35a9.28 9.28 0 0 1-.14 4.85c-5.08 3.24-9.14 7.57-13 12.13-.49.59-.63 1.71-1.87 1.29z"
          fill="#9D6BEC"
          fillRule="nonzero"
        />
        <path
          d="M374.85 60.11c-3.08 2.66-6.5 5-9.12 8.06-1.83 2.13-4 4.09-5.4 6.59-.5.88-1.41.84-2.27.84-1.11-1.2-.89-2.58-.57-4 3.72-5.39 8.48-9.78 13.4-14 .56-.49 1.13-1 2-.69a6.33 6.33 0 0 1 1.96 3.2z"
          fill="#8B71E9"
          fillRule="nonzero"
        />
        <path
          d="M372.87 56.91c-4.06 4.32-9.59 7.19-12.5 12.67a2.57 2.57 0 0 1-2.31 1.51 5.59 5.59 0 0 1 0-6.46c4.87-2.8 7.87-7.7 12.31-11a8.92 8.92 0 0 1 2.5 3.28z"
          fill="#8F6FE9"
          fillRule="nonzero"
        />
        <path
          d="M316.1 108.55a10 10 0 0 1-3.24-3.21c1.65-3.23 3.07-6.67 7-7.92a1.41 1.41 0 0 0 1.05-1.09c.53-3 2.65-2.53 4.71-2.24a5.72 5.72 0 0 1 2.66.6c.77 1 .16 1.88-.47 2.57a110.24 110.24 0 0 1-11.71 11.29z"
          fill="#946EEA"
          fillRule="nonzero"
        />
        <path
          d="M357.44 114.39c.1-.61-.65-1.41 0-1.79 4.7-2.8 7.12-8 11.72-11 2.56-1.64 3.56-4.95 6.14-6.72.45-.31.64-1.26 1.49-.61A37.63 37.63 0 0 1 363.58 111c-1.93 1.36-3.8 2.81-6.14 3.39z"
          fill="#6D7AE7"
          fillRule="nonzero"
        />
        <path
          d="M325.25 94.92c-1.85-.53-3.63-.93-3.7 2 0 .26-.28.7-.48.72-4.6.63-5.14 5.53-8.21 7.75a4.84 4.84 0 0 1-2.1-2.53c3.22-5 8-8.65 12-12.89a1.53 1.53 0 0 1 2.24-.17c1.49 1.65 1.33 3.37.25 5.12z"
          fill="#996DEB"
          fillRule="nonzero"
        />
        <path
          d="M379.39 44.08c3.32-4.72 7.62-8.56 11.6-12.68 1.56-1.62 1.08.85 1.8.92-.11 5.31-2.8 9-7.78 10.51-1.83.56-3.75.84-5.62 1.25z"
          fill="#9170EA"
          fillRule="nonzero"
        />
        <path
          d="M325 84c-1.81-1.89-2.51.12-3.3 1.07a112.7 112.7 0 0 1-13.58 13.88 2.85 2.85 0 0 1-1.11-2c5.67-6.36 11.83-12.22 18-18.09A3.64 3.64 0 0 1 325 84z"
          fill="#A16AEC"
          fillRule="nonzero"
        />
        <path
          d="M320.63 111.1c0 .28-.05.55-.07.82a3.08 3.08 0 0 1-1.91-1.36c-.88-2.72 1.5-4.08 2.91-5.15 3.46-2.64 5.71-6.28 8.72-9.26a14.82 14.82 0 0 1 1.72-1.48c4.18-2.55 6.26-7.21 10.12-10.1 1-.76 1.7-1.95 3.22-1.65.3.1.54.31.69.58-1.57 4.34-5.16 6.85-8.58 9.53-1.78 3-4.57 5.08-6.9 7.56-3.34 3.51-6.72 6.92-9.92 10.51z"
          fill="#8D70E9"
          fillRule="nonzero"
        />
        <path
          d="M384.64 22c-.52.09-1.31 0-1.51.31-3.23 4.83-8.43 7.65-12.12 12-.06-8.06 5.1-13.51 12.17-12.83a6.26 6.26 0 0 1 1.46.52z"
          fill="#A26BEC"
          fillRule="nonzero"
        />
        <path
          d="M358.06 80.77a10.21 10.21 0 0 0 3-2.13c4.27-4.76 8.84-9.24 13.31-13.82.66-.68 1.25-1.59 2.41-.84A6.46 6.46 0 0 1 378 67.2c-.4-.09-.81-.7-1.2 0-3.39 3-6.91 5.9-9.73 9.56-1.59 2-3.79 3.63-5.64 5.51-.92.94-2.35 1.6-3.67.25a1.53 1.53 0 0 1 .3-1.75z"
          fill="#8472E8"
          fillRule="nonzero"
        />
        <path
          d="M332.25 95a120.16 120.16 0 0 1-12 12.94c-.77.74-1.62 1.44-1.63 2.65a5.54 5.54 0 0 1-2.55-2c2.46-4.62 7.31-7 10.45-11a28.54 28.54 0 0 0 1.86-2.59c.69-.91 1.67-.8 2.64-.75.32.05.63.16.91.33.07.15.21.27.32.42z"
          fill="#906FEA"
          fillRule="nonzero"
        />
        <path
          d="M325.13 43.91c-1.93 2.08-4.37 3.81-6.12 5.8-2.36 2.69-5.28 4.89-7.34 7.89-.57.83-1.28 3.23-3.24 1.25a34 34 0 0 1 16.7-14.94z"
          fill="#C164EF"
          fillRule="nonzero"
        />
        <path
          d="M304.49 74.31c1 1.92-2 2.68-1.29 4.52 1.32 1.69 1 3.4.05 5.11l-.12.12c-1-2.59-.55-5.24-.36-7.88.59-.61.77-1.6 1.72-1.87z"
          fill="#B665EE"
          fillRule="nonzero"
        />
        <path
          d="M336.56 117.62l2.79-.07h5.16l1.5.1a17.73 17.73 0 0 1-9.45-.03z"
          fill="#7A75E8"
          fillRule="nonzero"
        />
        <path
          d="M358.06 80.77v1.93c1.24 1.51.79 3 0 4.52V93c0 .39 0 .78-.05 1.16-1.77-.06-2.42-1.89-3.87-2.45-.3-1.44-1.75-1.7-2.6-2.58a3.29 3.29 0 0 0-1.78-2c-.33-1.06-1.53-1.13-2.13-1.89a2.94 2.94 0 0 1-1.81-2c-.55-.44-1.28-.6-1.8-1.1-.86-1-2.16-1.66-2.33-3.16a1.31 1.31 0 0 1 .62-.71 5.08 5.08 0 0 1 1.93-.39c6.8-.07 5.67.17 5.82-6.37a4.09 4.09 0 0 1 .91-3.1c.29-5.41.29-5.42 5.73-5.17.43.04.85.1 1.27.19 0 .37 0 .74.08 1.11v16.23h.01zm-26.54 14.16l-3.14.11-3.13-.12-.22-5.12V69.15c.08-1.92.43-3.86-.32-5.74.39-.29.78-.63 1 .14l2.59 2.55 1.96 1.9 3.24 3.19 2.59 2.55 1.91 1.94a5 5 0 0 0 2 1.91c.53.17.89.46.76 1.09-1.13 1.35-2.7.86-4.12 1-1.13.11-2.32-.25-3.37.46a4.93 4.93 0 0 0-.55.8c-.45 3.38-.07 6.76-.2 10.14-.08 1.34.17 2.77-1 3.85z"
          fill="#FDFDFE"
          fillRule="nonzero"
        />
        <path
          d="M340.57 78.2l-.6-.61c3.92-2.73 6.23-7.4 11-9.09v3.23c-.37.37-.92.66-1 1.15-.76 3.3-3 5.08-6.08 6l-1.71.11c-.85.33-1.24-.2-1.61-.79z"
          fill="#946EEA"
          fillRule="nonzero"
        />
        <path
          d="M348.38 103.36c0-2.7 2.67-3.57 4-5.17a11.87 11.87 0 0 1 4.39-3.19c.33 3.15-3 3.41-4.36 5.24-.91 1.2-1.72 3.36-4.03 3.12zm-12.26 12.26c2-1.89 3-4.75 5.81-5.81-1.26 2.61-1.99 5.75-5.81 5.81zm10.33-9.68a2 2 0 0 1 1.29-1.94c.49.11 1.2.13 1 .85-.3 1.15-1.36 1.06-2.29 1.09zm-4.52 3.87c.8-1.2 1.59-2.42 3.23-2.58-.16 1.98-1.95 1.98-3.23 2.58z"
          fill="#7A75E8"
          fillRule="nonzero"
        />
        <path
          d="M325.72 63.55l-1-.14c-5.64 5.49-11.54 10.76-16.79 16.6-1.46 1.63-2.69 3.1-4.67 3.93 0-1.7 0-3.41-.05-5.11 2 .48 1.89-1.66 2.89-2.43 3.28-2.54 5.6-6 8.75-8.75 6.3-5.47 11.59-12 17.4-18 2.57-2.66 5.15-5.33 7.76-8 1.69-1.72 3.84-.77 5.8-.94-1.25 3.12-4.14 5-6.41 7-2.51 2.17-4 5.09-6.57 7.14-1.71 1.36-3.11 3.19-5 4.45-1.48 1.12-2.52 2.29-2.11 4.25z"
          fill="#B166ED"
          fillRule="nonzero"
        />
        <path
          d="M320.63 111.1c2-4.9 6.68-7.56 9.91-11.45a37.16 37.16 0 0 1 6.87-6.65c-.2 3.28-2.83 4.93-4.79 7-2.11 2.21-4.86 3.93-6.56 6.4a12.77 12.77 0 0 1-5.43 4.7zm25.19-27.77a3.28 3.28 0 0 1 1.81 2c-2 2.45-5.23 3.65-6.81 6.6-.7 1.3-2.19 1-3.41 1.12 2.51-3.51 6.35-5.85 8.41-9.72z"
          fill="#8D70E9"
          fillRule="nonzero"
        />
        <path
          d="M358.06 87.22V82.7c2.23-.08 3.25-1.67 4.77-3.07 4.43-4 8.15-8.78 12.76-12.62.2-.16.78.13 1.19.2-.61 2-1.12 3.74-3.65 4.63-1.82.63-3 3-4.3 4.6-3.24 4-7.31 7.07-10.77 10.78z"
          fill="#8372E8"
          fillRule="nonzero"
        />
        <path
          d="M344.53 82.05l1.3 1.28c-3.81 1.22-5.91 4.47-8.43 7.19-1.56 1.69-2.59 3.94-5.15 4.45-.56-.7-.23-1.52-.3-2.28.7-2.66 1.89-4.89 4.54-6.23 1.41-.71 1.95-2.48 3.17-3.55 1.48-1.28 2.97-2.12 4.87-.86z"
          fill="#906FEA"
          fillRule="nonzero"
        />
        <path
          d="M332.28 92.38v2.59h-.73c.05-4.16.07-8.32.16-12.48 0-1-.39-2.15.53-3 1.94 3 .94 6.38.86 9.59a8.34 8.34 0 0 1-.82 3.3z"
          fill="#9E75ED"
          fillRule="nonzero"
        />
        <path
          d="M332.28 92.38c0-4.32-.02-8.65-.07-13 3.29-.43 6.62-.43 9.91 0l2.41 2.65a4.7 4.7 0 0 0-5 2.09c-2 3.12-5.88 4.58-7.25 8.26z"
          fill="#946EEA"
          fillRule="nonzero"
        />
        <path
          d="M343.86 78.85c.05-.91.62-1.15 1.44-1.35a4.18 4.18 0 0 0 3.47-4c0-2 1.08-1.69 2.21-1.78.08 8.65 1.49 7.2-7.12 7.13z"
          fill="#916EEA"
          fillRule="nonzero"
        />
        <path
          d="M342.12 79.4h-9.91c1.65-1 3.48-.26 5.2-.53 1.07-.17 2.35.56 3.16-.72l1.58.75a3.4 3.4 0 0 0-.03.5z"
          fill="#9E75ED"
          fillRule="nonzero"
        />
        <path
          d="M113.58 203.41c.37-8.4 7.06-15.95 15.2-20 50-25 130.31-11.85 164-63.54"
          stroke="#D8C4F7"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M120.42 199.16l-.97-1.13-5.61 4.81-4.4-5.94-1.21.89 5.36 7.24zm174.66-71.79l-1.48.23-1.13-7.31-7.21 1.67-.34-1.47 8.78-2.02z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M224.51 240.88c11.33-5.49 16.34-19.79 15.88-32.56-.48-13.32-5.39-36.07-7.16-49.32-1.89-13.82-.29-28.34 6-40.78 6.1-12 24.58-26.69 39.52-26.21"
          stroke="#D8C4F7"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M231.76 243.71l.36-1.46-7.17-1.78 2.3-7.03-1.42-.47-2.81 8.56zm42.15-145.29l-1.04-1.09 5.32-5.13-5.51-4.93 1.01-1.12 6.7 6.01z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M350.93 231.72a43.15 43.15 0 0 0-.29-27.86c-3-8.22-8.47-15.2-11.1-23.56-3.52-11.2-1.22-33.51 5.8-43.68"
          stroke="#D8C4F7"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M358.13 228.66l-.76-1.29-6.36 3.77-3.31-6.61-1.34.67 4.02 8.06zm-10.1-84.49l-1.48.28-1.4-7.26-7.14 1.93-.39-1.45 8.69-2.35z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M517.5 235.24c3.71-12.89.67-24.88-9.52-35.82-19.25-20.67-46.2-26.72-73.78-31.22-23.51-3.84-46.45-10.26-53.83-33.94"
          stroke="#D8C4F7"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M524.61 231.94l-.81-1.27-6.23 3.99-3.53-6.5-1.32.72 4.3 7.92zm-136.74-95.02l-.71 1.33-6.53-3.47-2.98 6.76-1.38-.6 3.64-8.25z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M385.14 290.09a2.74 2.74 0 0 0 1.95 1.56c.94.19 1.35-1.26.4-1.45a1.36 1.36 0 0 1-1.06-.86.75.75 0 1 0-1.29.75zm-2.77 3.78l2.93.64c.94.2 1.34-1.24.4-1.45l-2.93-.64c-.94-.2-1.34 1.24-.4 1.45zm.63 5.36l3.74-.3c1-.08 1-1.58 0-1.5l-3.74.3c-1 .07-1 1.57 0 1.5z"
          fill="#18E8E3"
          fillRule="nonzero"
          opacity=".5"
        />
        <path
          d="M396.64 100.14c45.73 42.12 116.33 18.6 164.67 54.8 18 13.46 33 30.83 33.19 53"
          stroke="#D8C4F7"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M396.28 108l1.5-.14-.68-7.36 7.39-.14-.03-1.5-9.01.17zm191.83 95.25l1.06-1.06 5.24 5.22 4.82-5.61 1.14.98-5.88 6.83z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M596.72 256.65a14.11 14.11 0 0 0 5.91 1.06l-.2-1.48a6.74 6.74 0 0 1-5.58-.53c-.85-.47-1.6.83-.76 1.3a8.29 8.29 0 0 0 6.74.68.75.75 0 0 0-.2-1.47 13.18 13.18 0 0 1-5.51-1c-.89-.37-1.28 1.08-.4 1.44zm2.18-13.8l4.09 8 .45-1.11a14.47 14.47 0 0 1-3.92.81c-.95.06-1 1.56 0 1.5a16.32 16.32 0 0 0 4.32-.86.76.76 0 0 0 .45-1.1l-4.09-7.95c-.44-.86-1.74-.1-1.3.76v-.05z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M617.36 224.71c-5.42 1.6-10.53-2.06-15.9-2.44a20 20 0 0 0-12.23 3.27c-3.05 2-6 5-7.21 8.55-1.61 4.67 2.94 10.23 4.58 14.51.95 2.49 3.95 2.34 3.91-.67l-.14-9.63a.68.68 0 0 0 0-.14c9.65-4 24.51 2.33 29.83-9.78.8-1.87-.56-4.38-2.84-3.67z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M477 259.15l3 .12a.68.68 0 0 0 .7-.69.75.75 0 0 0-.72-.81l-2.14-.08a35.23 35.23 0 0 0 .67-7.39.73.73 0 0 0-.76-.73.71.71 0 0 0-.73.73 32.69 32.69 0 0 1-.8 7.91.79.79 0 0 0 .14.65.76.76 0 0 0 .64.29zm10.58-5.41a4.75 4.75 0 0 0-4.76-.46.74.74 0 0 0-.48.39.79.79 0 0 0 .16.73.7.7 0 0 0 .67.23 6.87 6.87 0 0 1 4 .44.57.57 0 0 0 .59-.05.78.78 0 0 0 .26-.69.73.73 0 0 0-.44-.59zm-12.53-.97a4.07 4.07 0 0 0-4.26-.41c-.2.09-.37.16-.43.35a.68.68 0 0 0 .14.65.62.62 0 0 0 .6.21 6.11 6.11 0 0 1 3.59.4.69.69 0 0 0 .24.05.53.53 0 0 0 .29-.1.69.69 0 0 0 .23-.62.65.65 0 0 0-.4-.53zm7.26 9.83a8.71 8.71 0 0 1-5.71-.47 1 1 0 0 0-1.33.43.64.64 0 0 0 .41.88 6.75 6.75 0 0 0 3.44.93h1.14c.2.31.55.5.92.49.13 0 .26-.02.39-.06a4.42 4.42 0 0 0 1.65-.94.7.7 0 0 0 .16-.86.91.91 0 0 0-1.07-.4z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M489.28 233a16.2 16.2 0 0 1 4.57 6.75 6.18 6.18 0 0 1 .38 3.47c-.42 1.75-2 3-3.57 3.85a23.27 23.27 0 0 1-22.92-.44c3.91-2.09 4.63-7.35 7.36-10.86 3.07-3.95 9.33-5.21 13.38-2.27 3.4 2.48 4.59 7 5.3 11.11.07.4-.32 1-.54.68"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M314.23 26.55a133.27 133.27 0 0 0-12.9-19.36c-.8-1-2.21.42-1.41 1.41a131 131 0 0 1 12.58 19c.62 1.09 2.34.09 1.73-1.05zM336.54 1v20a1 1 0 1 0 2 0V1a1 1 0 1 0-2 0zM302 33.1l-6-4c-1.07-.71-2.08 1-1 1.73l6 4c1.1.72 2.11-1.02 1-1.73zm52.91-24.52a54.9 54.9 0 0 0-4.62 14.07c-.23 1.26 1.69 1.8 1.93.53a52.49 52.49 0 0 1 4.42-13.59c.56-1.15-1.17-2.17-1.73-1.01zm-27.39 14.11l-4-12c-.41-1.21-2.34-.69-1.93.54l4 12c.41 1.21 2.34.69 1.93-.54zM82.22 279.67c0-.21 0-.43.06-.65.11-1.93-2.89-1.92-3 0a11 11 0 0 1-.87 3.65 1.52 1.52 0 0 0 1 1.85 3.3 3.3 0 0 0 3.76-1.31 2.59 2.59 0 0 0-.95-3.54z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M88 305.41c-.81-7-4.15-13.37-4.94-20.48a1.64 1.64 0 0 0-2-1.4 1.41 1.41 0 0 0-2.17 1.25c1 12 2.41 23.9 3.9 35.8a1.59 1.59 0 0 0 1.1 1.45l2 .79a1.5 1.5 0 0 0 1.9-1.44c.26-5.27.84-10.72.21-15.97z"
          fill="#D8C4F7"
          fillRule="nonzero"
        />
        <path
          d="M589.8 279.3c-.44 6.51 2.61 12.88 5.51 18.53a10.38 10.38 0 0 0 3 3.8c10.13 7.24 12.26-18.45 13.6-22.52"
          stroke="#18E8E3"
        />
        <path
          d="M601.12 303.11l.55 6.17c.12 1.27 2.12 1.29 2 0l-.55-6.17c-.11-1.28-2.11-1.29-2 0z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M600.56 306.79l4.17-.19c1.28-.06 1.29-2.06 0-2l-4.17.19c-1.28.06-1.29 2.06 0 2z"
          fill="#18E8E3"
          fillRule="nonzero"
        />
        <path
          d="M76.47 251.52a6.53 6.53 0 0 0 5.47.56c1.36-.47.77-2.64-.6-2.17a4.33 4.33 0 0 1-3.73-.33 1.13 1.13 0 0 0-1.14 1.94z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M529.74 513.3c-.87-1.66-3.39-.19-2.52 1.47 4.22 8.05 5.68 17.52-4.19 22-1.7.78-.22 3.29 1.47 2.52a15.71 15.71 0 0 0 8.86-10.51c1.36-5.52-1.1-10.67-3.62-15.48z"
          fill="#592C76"
          fillRule="nonzero"
        />
        <path
          d="M501.92 379.84c3.28 18.41 8.37 51.35 12.89 81.1 4.56 30 13.4 48.08 14.34 53.37a1 1 0 0 1-.74 1.24c-3.42.77-31.22-44.8-34.37-56.39-5.63-20.66-9.37-36.55-15.29-57.12-2.87-10 3.52-22.33 1-32.42-.14-.59 21.92 8.92 22.15 10.22h.02z"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#59E8E2"
          strokeWidth="2"
        />
        <path
          d="M491.75 279.71c-7.46 9.38-9.78 13.87-9.78 13.87l-8.57-13.79c-1.91.21-10 2.37-17.3 4.49a6.81 6.81 0 0 0-4.62 8.44l7.17 31.2s-10.08 52-12.55 68.89a2 2 0 0 0 1.36 2.19c29.18 9.23 68.15 3.27 68.15 3.27 1.95-10.68-4.33-71-4.33-71-.08-23 6.12-34.55 6.12-34.55-5.86-4.92-15.22-10.47-24.61-12.65"
          fill="#6A25D6"
          fillRule="nonzero"
        />
        <path
          d="M474.05 326.06l13.32 1c.94.07 1.29.49.5.6-2.8.4-6.46-.06-10.4-.13"
          fill="#9978FF"
          fillRule="nonzero"
          stroke="#9978FF"
        />
        <path
          d="M515.6 320.4c3.06 4.42 6.06 13.26 5.22 18.18-1.18 6.9-18.2 3.75-24 8.57-1.64 1.38-1.49 3.06-.27 4.51 3.74.72 7-2.45 10.75-2.84 5.72-.59 13.68-.38 18.5-3.3 12.11-7.34 5.6-19 .36-28.71"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M470.33 281.21C471.76 285 482.62 300 482.62 300c3.27-7.12 9.46-12.27 12.28-19.35"
          stroke="#D8C4F7"
        />
        <path
          d="M532.51 318.27c-2.5-9.49-9-19-15.11-25.55l-4.6 2.51c-1.68 11.55-3.53 18.61-3.3 19.91 3.22 3.68 5.28 5.41 6.88 11.07a2 2 0 0 0 3 1.15c3.69-2.3 9.2-4.65 12.42-7a2 2 0 0 0 .71-2.09z"
          fill="#6A25D6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components-legacy/SVG/IllustrationNewWay.js